import React, { useContext } from 'react';
import { Redirect, Switch } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';
import loadable from '@loadable/component';
import { AppContext } from 'adapter';

const AccountView = loadable(() => import('./views/Account'));
const MineView = loadable(() => import('./views/Mine'));
const NotFoundView = loadable(() => import('./views/NotFound'));
const SignInView = loadable(() => import('./views/SignIn'));
const SignUpView = loadable(() => import('./views/SignUp'));
const SystemView = loadable(() => import('./views/System'));
const MetricsView = loadable(() => import('./views/Metric'));
// custom

const ProjectListView = loadable(() => import('./views/Project/projectList'));
const ProjectEditFormView = loadable(
  () => import('./views/Project/common/ProjectEditForm')
);
const ProjectWorkSpaceView = loadable(
  () => import('./views/Project/projectWorkspace')
);

const ApkAssetsListView = loadable(() => import('./views/ApkAsset'));

const ZedEngineView = loadable(() => import('./views/ZedEngine'));
const DeviceWorkSpaceView = loadable(() => import('./views/Device/workspace'));
const DeviceDetailView = loadable(() => import('./views/Device/detail'));
const LiveWallViewerView = loadable(
  () => import('./views/Device/workspace/LiveWallViewer')
);
const ShareDiskView = loadable(() => import('./views/ShareDisk'));

const DevicePreview = loadable(() => import('./views/Project/DevicePreview'));
const DeviceLog = loadable(() => import('./views/DeviceLog'));

const PrivateRoute = ({ ...rest }) => {
  const { user } = useContext(AppContext);
  return !user.overdue ? (
    <RouteWithLayout {...rest} />
  ) : (
    <Redirect
      to={{
        pathname: '/sign-in',
      }}
    />
  );
};

const Routes = () => {
  return (
    <Switch>
      <Redirect exact from='/' to='/mine' />
      <PrivateRoute
        component={AccountView}
        exact
        layout={MainLayout}
        path='/accountList'
      />
      <PrivateRoute
        component={MineView}
        exact
        layout={MainLayout}
        path='/mine'
      />
      <PrivateRoute
        component={SystemView}
        exact
        layout={MainLayout}
        path='/systemSettings'
      />

      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path='/sign-in'
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path='/sign-up'
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path='/not-found'
      />
      <PrivateRoute
        component={MetricsView}
        exact
        layout={MainLayout}
        path='/metrics'
      />
      {/* custom begin */}
      <PrivateRoute
        component={ProjectListView}
        exact
        layout={MainLayout}
        path='/projectList'
      />
      <PrivateRoute
        component={ProjectEditFormView}
        exact
        layout={MainLayout}
        path='/projectEdit/:projectId?'
      />
      <PrivateRoute
        component={ProjectWorkSpaceView}
        exact
        layout={MainLayout}
        path='/projectWorkSpace/:projectId'
      />
      <PrivateRoute
        component={ApkAssetsListView}
        exact
        layout={MainLayout}
        path='/apkAssets'
      />

      <PrivateRoute
        component={ZedEngineView}
        exact
        layout={MainLayout}
        path='/zedEngineList'
      />

      <PrivateRoute
        component={DeviceWorkSpaceView}
        exact
        layout={MainLayout}
        path='/device'
      />
      <PrivateRoute
        component={DeviceDetailView}
        exact
        layout={MainLayout}
        path='/deviceDetail/:deviceUuid'
      />

      <PrivateRoute
        component={LiveWallViewerView}
        exact
        layout={MainLayout}
        path='/liveWallView/:wallId'
      />
      <PrivateRoute
        component={ShareDiskView}
        exact
        layout={MainLayout}
        path='/shareDisk'
      />
      <PrivateRoute
        component={DevicePreview}
        exact
        layout={MainLayout}
        path='/devicePreview/:ids'
      />
      <PrivateRoute
        component={DeviceLog}
        exact
        layout={MainLayout}
        path='/deviceLog'
      />
      <Redirect to='/not-found' />
    </Switch>
  );
};

export default Routes;
